// extracted by mini-css-extract-plugin
export default {"separator":"style_separator__y6TFg"};